/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LinkEditItem } from './LinkEditItem';
import {
    LinkEditItemFromJSON,
    LinkEditItemFromJSONTyped,
    LinkEditItemToJSON,
} from './LinkEditItem';

/**
 * 
 * @export
 * @interface LinkListSectionParameters
 */
export interface LinkListSectionParameters {
    /**
     * 
     * @type {Array<LinkEditItem>}
     * @memberof LinkListSectionParameters
     */
    links: Array<LinkEditItem>;
    /**
     * 
     * @type {string}
     * @memberof LinkListSectionParameters
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkListSectionParameters
     */
    description?: string;
}

/**
 * Check if a given object implements the LinkListSectionParameters interface.
 */
export function instanceOfLinkListSectionParameters(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "links" in value;

    return isInstance;
}

export function LinkListSectionParametersFromJSON(json: any): LinkListSectionParameters {
    return LinkListSectionParametersFromJSONTyped(json, false);
}

export function LinkListSectionParametersFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkListSectionParameters {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'links': ((json['links'] as Array<any>).map(LinkEditItemFromJSON)),
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function LinkListSectionParametersToJSON(value?: LinkListSectionParameters | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'links': ((value.links as Array<any>).map(LinkEditItemToJSON)),
        'title': value.title,
        'description': value.description,
    };
}

